import { useEffect, useState } from "react";
import { Play } from "lucide-react";
import { Player } from "video-react";
import EmbedVideo from "../EmbedVideo";

const Preview = ({ formData }) => {
  const [videoExtension, setVideoExtension] = useState("");
  const [videoId, setVideoId] = useState("");
  const [buttonOneLink, setButtonOneLink] = useState("");
  const [buttonTwoLink, setButtonTwoLink] = useState("");

  useEffect(() => {
    const extension =
      formData.video_link && formData.video_link.split(".").pop().toLowerCase();
    setVideoExtension(extension);
    const vId =
      formData.video_link && formData.video_link.split("/").pop().toLowerCase();
    setVideoId(vId);
    const BtnOneLink =
      formData.button_one_link && formData.button_one_link.includes("https")
        ? formData.button_one_link
        : `https://${formData.button_one_link}`;
    setButtonOneLink(BtnOneLink);
    const BtnTwoLink =
      formData.button_two_link && formData.button_two_link.includes("https")
        ? formData.button_two_link
        : `https://${formData.button_two_link}`;
    setButtonTwoLink(BtnTwoLink);

    // Start Chatbot embedding
    const regex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/i;

    if (formData.bot_script && regex.test(formData.bot_script)) {
      const htmlString = String(formData.bot_script);

      // Regular expression to match script tags
      const scriptTags = htmlString.match(/<script[^>]*>([\s\S]*?)<\/script>/g);
      let script;
      scriptTags &&
        scriptTags.length > 0 &&
        scriptTags.forEach((item, i) => {
          if (i !== scriptTags.length - 1) {
            script = document.createElement("script");
            const srcValue = String(item).match(/src="([^"]+)"/)[1];
            script.async = true;
            script.src = srcValue;
            document.body.appendChild(script);
          } else {
            // Regular expression to match the content inside <script> tags
            const regex = /<script>([\s\S]*?)<\/script>/;
            const match = item.match(regex);

            if (match && match[1]) {
              const scriptContent = match[1].trim();
              script.async = true;
              script.onload = () => {
                // Create a new script element
                const scriptElement = document.createElement("script");
                scriptElement.textContent = scriptContent;

                // Append the script element to the body or a specific container
                document.body.appendChild(scriptElement);

                setTimeout(() => {
                  // Select Chatbot
                  const widgetRoots = document.querySelectorAll(
                    "#avachats-widget-root"
                  );

                  widgetRoots.forEach((widget, i) => {
                    const shadowRoot = widget.shadowRoot;
                    const avachatsWidget =
                      shadowRoot.querySelector(".avachats-widget");
                    if (avachatsWidget !== null) {
                      avachatsWidget.style.position = "relative";
                      avachatsWidget.style.width = "auto";
                      avachatsWidget.style.height = "auto";
                      // avachatsWidget.querySelector("button").style.marginLeft =
                      //   "96rem";
                    }
                  });
                }, 4000);
              };

              return () => {
                document.body.removeChild(script);
              };
            } else {
              console.log("No script content found.");
            }
            // End Chatbot embedding
          }
        });
    }
  }, [formData]);

  return (
    <div className="mx-auto">
      <main className="max-w-6xl mx-auto px-4 py-4">
        {/* Header */}
        {formData.page_header_text && (
          <div className="mb-8">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-2 mx-auto text-center max-md:text-3xl">
              {formData.page_header_text.includes("{{first_name}}")
                ? formData.page_header_text.replace(
                    "{{first_name}}",
                    formData.lead_name.split(" ")[0]
                  )
                : formData.page_header_text}
            </h1>
          </div>
        )}
        <div className="grid md:grid-cols-[350px,1fr] gap-12 items-start">
          {/* Left Column */}
          <div className="space-y-4">
            <div className="h-full">
              <div className="bg-white rounded-2xl shadow-xl p-6 space-y-6 h-full">
                <div className="space-y-8">
                  {formData.campaign_name && (
                    <h2 className="text-xl text-center font-semibold text-gray-900">
                      {formData.campaign_name}
                    </h2>
                  )}

                  <div className="flex items-center gap-4 justify-center">
                    {formData.file_url && (
                      <img
                        src={formData.file_url}
                        alt={formData.file_url}
                        className="w-24 h-24 rounded-full object-cover"
                      />
                    )}
                    <div className="w-24 h-24 bg-indigo-600 rounded-2xl flex items-center justify-center">
                      <Play className="w-12 h-12 text-white" />
                    </div>
                  </div>

                  {formData.left_navigation && (
                    <p className="text-center text-gray-600 font-medium">
                      {formData.left_navigation.includes("{{first_name}}")
                        ? formData.left_navigation.replace(
                            "{{first_name}}",
                            formData.lead_name.split(" ")[0]
                          )
                        : formData.left_navigation}
                    </p>
                  )}
                </div>

                <div className="space-y-3">
                  {buttonOneLink && formData.button_one_text && (
                    <a
                      href={buttonOneLink !== "" ? buttonOneLink : "#"}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <button className="w-full mb-4 py-3 px-6 bg-indigo-600 text-white rounded-lg font-semibold hover:bg-indigo-700 transition-colors">
                        {formData.button_one_text.includes("{{first_name}}")
                          ? formData.button_one_text.replace(
                              "{{first_name}}",
                              formData.lead_name.split(" ")[0]
                            )
                          : formData.button_one_text}
                      </button>
                    </a>
                  )}

                  {buttonTwoLink && formData.button_two_text && (
                    <a
                      href={buttonTwoLink ? buttonTwoLink : "#"}
                      rel="noreferrer"
                      target="_blank"
                    >
                      <button className="w-full py-3 px-6 border-2 border-gray-200 text-gray-700 rounded-lg font-semibold hover:border-gray-300 transition-colors">
                        {formData.button_two_text.includes("{{first_name}}")
                          ? formData.button_two_text.replace(
                              "{{first_name}}",
                              formData.lead_name.split(" ")[0]
                            )
                          : formData.button_two_text}
                      </button>
                    </a>
                  )}
                </div>
              </div>

              <div class="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-lg p-3 mt-6">
                <a
                  href="https://jadaworks.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="flex items-center justify-center gap-2 text-sm font-medium text-indigo-600 hover:text-indigo-700 transition-colors group"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-sparkles w-4 h-4 text-indigo-500 group-hover:text-indigo-600"
                  >
                    <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"></path>
                    <path d="M5 3v4"></path>
                    <path d="M19 17v4"></path>
                    <path d="M3 5h4"></path>
                    <path d="M17 19h4"></path>
                  </svg>
                  Powered by Jada
                </a>
              </div>
            </div>
          </div>

          {formData.video_title && formData.video_link && videoId && (
            <div className="space-y-6">
              <h2 className="text-2xl font-semibold text-center text-gray-900 max-md:text-lg">
                {formData.video_title.includes("{{first_name}}")
                  ? formData.video_title.replace(
                      "{{first_name}}",
                      formData.lead_name.split(" ")[0]
                    )
                  : formData.video_title}
              </h2>
              {["mp4", "webm", "ogg"].includes(videoExtension) ? (
                <Player src={formData.video_link} />
              ) : (
                <EmbedVideo video_id={videoId} />
              )}
            </div>
          )}
        </div>
        <div />
      </main>
    </div>
  );
};

export default Preview;
